import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { HR } from 'foundations-components/transitional/components/HR';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { ContainerTemplate } from './ContainerTemplate';
import { EnterpriseManagedAuthTile } from '../enterpriseManagedAuth/EnterpriseManagedAuthTile';
import { RevokeApprovalModal } from '../RevokeApprovalModal';
import { UsersWithInstallAccessDrawer } from '../UsersWithInstallAccessDrawer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Advanced() {
  const [showRevokeApprovalModal, setShowRevokeApprovalModal] = useState(false);
  const [showUsersWithInstallAccessDrawer, setShowUsersWithInstallAccessDrawer] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showUsersWithInstallAccessDrawer && /*#__PURE__*/_jsx(UsersWithInstallAccessDrawer, {
      onClose: () => setShowUsersWithInstallAccessDrawer(false)
    }), showRevokeApprovalModal && /*#__PURE__*/_jsx(RevokeApprovalModal, {
      onClose: () => setShowRevokeApprovalModal(false),
      showUsersWithInstallAccessDrawer: () => {
        setShowUsersWithInstallAccessDrawer(true);
        // We want the modal to be closed when the users with install access drawer is shown, just so there aren't overwhelming dialogs
        setShowRevokeApprovalModal(false);
      }
    }), /*#__PURE__*/_jsxs(ContainerTemplate, {
      children: [/*#__PURE__*/_jsx(EnterpriseManagedAuthTile, {}), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.revokeApproval.title"
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.revokeApproval.description"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-selenium": "revoke-approval-open-modal",
        use: "danger",
        onClick: () => setShowRevokeApprovalModal(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.revokeApproval.button"
        })
      })]
    })]
  });
}